<template>
  <transition :name="!scrollUp ? 'toTop-out' : 'reverse-toTop-out'">
    <section v-show="isActive" class="main-bar">
      <div class="books" :class="isActive ? '' : 'books-move'">
        <img :src="require('@/assets/lifestyle-page/book.png')" />
      </div>
      <div class="grid">
        <transition :name="!scrollUp ? 'fromtop-card' : ''">
          <router-link
            v-if="list[0]"
            :to="
              $i18nRoute({
                name: 'NewsDetail',
                params: { slug: list[0].url }
              })
            "
            class="grid__item"
            v-show="isActive"
          >
            <div class="card card-1">
              <div class="card__img">
                <div class="card__category-img">
                  {{ list[0].sub_category.name }}
                </div>

                <div
                  class="bg-img-frame"
                  :style="{
                    background: `url(${list[0].image.medium})`,
                    backgroundRepeat: 'no-repeat',
                    backgroundSize: 'cover',
                    backgroundPositionY: '-5px'
                  }"
                >
                  <img
                    class="frame-img"
                    :src="require('@/assets/lifestyle-page/black-frame.png')"
                    alt="Background Image"
                  />
                </div>
              </div>
              <div class="card__desc">
                <div class="card__title limited-text">
                  {{ list[0].title }}
                </div>
                <div class="data-news">
                  <span class="day">{{ handleDate(list[0].pub_date) }},</span>
                  <span class="time">{{ handleTime(list[0].pub_date) }}</span>
                </div>
              </div>
            </div>
          </router-link>
        </transition>
        <transition :name="!scrollUp ? 'fromtop-card' : ''">
          <router-link
            v-if="list[1]"
            :to="
              $i18nRoute({
                name: 'NewsDetail',
                params: { slug: list[1].url }
              })
            "
            class="grid__item"
            v-show="isActive"
          >
            <div class="card card-2">
              <div class="card__img">
                <div class="card__category-img">
                  {{ list[1].sub_category.name }}
                </div>
                <img
                  class="bg-img-frame"
                  :src="list[1].image.medium"
                  alt="Background Image"
                />
                <img
                  class="frame-img"
                  :src="
                    isDescktop
                      ? require('@/assets/lifestyle-page/light-frame.png')
                      : require('@/assets/lifestyle-page/black-frame.png')
                  "
                  alt="Background Image"
                />
              </div>
              <div class="card__desc">
                <div class="card__title limited-text">
                  {{ list[1].title }}
                </div>
                <div class="data-news">
                  <span class="day">{{ handleDate(list[1].pub_date) }},</span>
                  <span class="time">{{ handleTime(list[1].pub_date) }}</span>
                </div>
              </div>
            </div>
          </router-link>
        </transition>
        <transition :name="!scrollUp ? 'fromtop-card' : ''">
          <router-link
            v-if="list[2]"
            :to="
              $i18nRoute({
                name: 'NewsDetail',
                params: { slug: list[2].url }
              })
            "
            class="grid__item"
            v-show="isActive"
          >
            <div class="card card-3">
              <div class="card__img">
                <div class="card__category-img">
                  {{ list[2].sub_category.name }}
                </div>
                <div
                  class="bg-img-frame"
                  :style="{
                    background: `url(${list[2].image.medium})`,
                    backgroundRepeat: 'no-repeat',
                    backgroundSize: 'cover',
                    backgroundPositionY: '0px'
                  }"
                >
                  <img
                    class="frame-img"
                    :src="require('@/assets/lifestyle-page/black-frame.png')"
                    alt="Background Image"
                  />
                </div>
              </div>
              <div class="card__desc">
                <div class="card__title limited-text">
                  {{ list[2].title }}
                </div>
                <div class="data-news">
                  <span class="day">{{ handleDate(list[2].pub_date) }},</span>
                  <span class="time">{{ handleTime(list[2].pub_date) }}</span>
                </div>
              </div>
            </div>
          </router-link>
        </transition>
        <transition name="scale-laptop">
          <router-link
            v-if="list[3]"
            :to="
              $i18nRoute({
                name: 'NewsDetail',
                params: { slug: list[3].url }
              })
            "
            v-show="isActive"
            class="grid__item"
          >
            <div>
              <img
                class="imac-img"
                :src="require('@/assets/lifestyle-page/imac.png')"
                alt="Background Image"
              />

              <div class="card card-4">
                <div class="card__img">
                  <div class="card__category-img">
                    {{ list[3].sub_category.name }}
                  </div>

                  <ImageContainer
                    class="img"
                    :src="list[3].image.medium"
                    :thumb="list[3].image.thumbnail"
                    :alt="list[3].title"
                  />
                </div>
                <div class="card__desc">
                  <div class="card__title">
                    {{ list[3].title }}
                  </div>
                  <div class="data-news">
                    <span class="day">{{ handleDate(list[3].pub_date) }},</span>
                    <span class="time">{{ handleTime(list[3].pub_date) }}</span>
                  </div>
                </div>
              </div>
            </div>
          </router-link>
        </transition>
        <transition :name="!scrollUp ? 'fromtop-card' : ''">
          <router-link
            v-if="list[4]"
            :to="
              $i18nRoute({
                name: 'NewsDetail',
                params: { slug: list[4].url }
              })
            "
            class="grid__item"
            v-show="isActive"
          >
            <div class="card card-5">
              <div class="card__img">
                <div class="card__category-img">
                  {{ list[4].sub_category.name }}
                </div>
                <div
                  class="bg-img-frame"
                  :style="{
                    background: `url(${list[4].image.medium})`,
                    backgroundRepeat: 'no-repeat',
                    backgroundSize: 'cover',
                    backgroundPositionY: '-5px'
                  }"
                >
                  <img
                    class="frame-img"
                    :src="require('@/assets/lifestyle-page/black-frame.png')"
                    alt="Background Image"
                  />
                </div>
              </div>
              <div class="card__desc">
                <div class="card__title limited-text">
                  {{ list[4].title }}
                </div>

                <div class="data-news">
                  <span class="day">{{ handleDate(list[4].pub_date) }},</span>
                  <span class="time">{{ handleTime(list[4].pub_date) }}</span>
                </div>
              </div>
            </div>
          </router-link>
        </transition>
      </div>
    </section>
  </transition>
</template>

<script>
import { useFormatter } from "@/utils/formatter";
import ImageContainer from "@/components/ImageContainer";
import { ref, onBeforeUnmount, onMounted } from "vue";

export default {
  components: { ImageContainer },

  props: {
    list: {
      type: Array,
      required: true
    },
    isActive: {
      type: Boolean,
      required: true
    },
    scrollUp: {
      type: Boolean,
      required: true
    }
  },

  setup() {
    const isDescktop = ref(true);

    const checkWidth = () => {
      if (typeof window !== "undefined") {
        if (window.innerWidth >= 992) {
          isDescktop.value = true;
        }

        if (window.innerWidth < 992) {
          isDescktop.value = false;
        }
      }
    };

    var resizeTimeout;
    function resizeThrottler() {
      if (!resizeTimeout) {
        resizeTimeout = setTimeout(function() {
          resizeTimeout = null;
          checkWidth();

          // The checkWidth will execute at a rate of 15fps
        }, 66);
      }
    }

    onMounted(() => {
      checkWidth();
      window.addEventListener("resize", resizeThrottler, false);
    });
    onBeforeUnmount(() => {
      window.removeEventListener("resize", resizeThrottler);
    });

    return {
      ...useFormatter(),
      isDescktop
    };
  }
};
</script>
<style lang="scss" scoped>
img {
  width: 100%;
  height: auto;
}
.card {
  color: var(--black-bg);
  .frame-img {
    background-color: transparent;
  }
  &__category-img {
    color: var(--category-color);
  }
  .data-news {
    color: var(--data-color);
  }
}
.main-bar {
  width: 100%;
  height: 100vh;
  background: url("../../assets/lifestyle-page/main-bar-bg.jpg") no-repeat
    bottom;
  background-size: cover;
  color: #121212;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 10;
  transition: all 0.4s;
  // scroll-snap-align: start;
}
.books {
  position: absolute;
  right: 0;
  bottom: 40%;
  width: 7%;
  img {
    background-color: transparent;
  }
}
.bg-img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  object-fit: cover;
  z-index: 0;
}
.card-3,
.card-5 {
  --width-img: 13vw;
  .img {
    border-radius: 0px;
    left: 0;
    z-index: 1;
    :deep() img {
      border-radius: 0px;
    }
  }
  .card__desc {
    position: relative;
    z-index: 3;
  }
  .card__img {
    position: relative;
    z-index: 0;
    .frame-img {
      background-color: transparent;
      transform: scale(1.06);
      top: 0;
      left: 0;
      z-index: 2;
      width: var(--width-img);
      -webkit-box-shadow: -20px 12px 23px -7px rgba(34, 60, 80, 0.42);
      -moz-box-shadow: -20px 12px 23px -7px rgba(34, 60, 80, 0.42);
      box-shadow: -20px 12px 23px -7px rgba(34, 60, 80, 0.42);
    }
    .bg-img-frame {
      width: var(--width-img);
      height: auto;
      background-repeat: no-repeat;
      background-size: cover;
    }
    .card__category-img {
      // transform: translateY(10px);
      top: 0;
    }
  }
}
.card-1 {
  display: flex;
  gap: 1rem;
  transform: translateY(-7vh);
  max-width: 70%;
  .card__desc {
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 0.5rem;
  }
  .card__img {
    --width-img: 14vw;
    position: relative;
    z-index: 0;
    .frame-img {
      position: relative;
      background-color: transparent;
      top: 0;
      left: 2px;
      z-index: 2;
      width: var(--width-img);
      // height: 200px;
      -webkit-box-shadow: -20px 12px 23px -7px rgba(34, 60, 80, 0.42);
      -moz-box-shadow: -20px 12px 23px -7px rgba(34, 60, 80, 0.42);
      box-shadow: -20px 12px 23px -7px rgba(34, 60, 80, 0.42);
      transform: scale(1.1);
    }
    .bg-img-frame {
      width: calc(var(--width-img) + 4px);
      height: auto;
      background-repeat: no-repeat;
      background-size: cover;
    }
    .card__category-img {
      // transform: translateY(10px);
      top: 0;
    }
  }
  .card__category-img {
    margin-bottom: 0.5rem;
  }
}
.card-2 {
  transform: rotate(6deg) translate(10%, 0%);
  position: relative;
  width: 16vw;
  transition: 0.4s ease-out;
  @media screen and (max-width: 1300px) {
    transform: rotate(6deg) translate(-40%, 0%);
  }
  .frame-img {
    background-color: transparent;
    position: absolute;
    bottom: 0px;
    width: 16vw;
    z-index: 2;
  }
  .bg-img-frame {
    position: absolute;
    bottom: 0;
    width: 15vw;
    height: 11vw;
  }
  .card__img {
    position: relative;
  }
}
.card-3 {
  transform: translateX(40px);
  .card__category-img {
    margin-bottom: 0.5rem;
  }
}
.card-4 {
  position: absolute;
  top: 12%;
  z-index: 2;
  width: 70%;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  gap: 1rem;
  .card__img {
    position: relative;
    flex: 0 0 50%;
    .img {
      clip-path: polygon(25% 13%, 25% 0, 100% 0, 100% 100%, 0 100%, 0 13%);
      height: 17vh;
    }
  }
  .card__category-img {
    position: absolute;
    z-index: 2;
    top: 0;
    left: 0;
    color: #fff;
  }
  .card__desc {
    color: #fff;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  .data-news {
    color: rgba(255, 255, 255, 0.8);
  }
}
.card-5 {
  transform: translate(10%, 20%);
  .card__category-img {
    margin-bottom: 0.5rem;
  }
}
.grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr) repeat(2, minmax(350px, 1fr)) repeat(
      2,
      1fr
    );
  grid-template-rows: 45vh 54vh;
  &__item {
    transition: all 0.4s;
  }
  &__item:nth-child(1) {
    grid-column: 3 / span 2;
    align-self: end;
  }
  &__item:nth-child(2) {
    grid-column: 5 / span 1;
    align-self: end;
  }
  &__item:nth-child(3) {
    grid-column: 2 / span 1;
    justify-self: self-end;
  }
  &__item:nth-child(4) {
    grid-column: 3 / span 2;
    position: relative;
    height: 100%;
    .imac-img {
      position: absolute;
      bottom: 0;
      background-color: transparent;
      z-index: 2;
    }
  }
  &__item:nth-child(5) {
    grid-column: 5 / span 1;
  }
}
.fromtop-out-enter-active,
.fromtop-out-leave-active {
  transition: all 1s ease !important;
}
.secondBar-enter-active,
.secondBar-leave-active {
  transition: all 0.6s;
}
.secondBar-enter-from {
  transform: translateY(-100%);
}
.reverse-toTop-out-leave-active,
.reverse-toTop-out-enter-active {
  transition: all 0.6s;
}
.reverse-toTop-out-enter-to {
  animation: top-visible 1s;
  // animation-duration: 1.2s;
}
.reverse-toTop-out-enter-from {
  transform: translateY(-100%);
}
.reverse-toTop-out-leave-to {
  transform: translateY(100%);
}

.toTop-out-enter-active,
.toTop-out-leave-active {
  transition: all 0.6s ease-out;
}

.toTop-out-leave-to {
  animation: top-hidden 1s;
}
.toTop-out-enter-to {
  transform: translateY(0%);
}
.toTop-out-enter-from {
  transform: translateY(100%);
}
.scale-laptop-enter-active,
.scale-laptop-leave-active {
  transition: all 0.6s !important;
}
.scale-laptop-leave-to {
  transform: scale(0.8);
}

.scale-laptop-enter-active {
  transition-delay: all 0.6s !important;
}
.scale-laptop-enter-from {
  transform: scale(0.6);
}

.books-move {
  animation: books-move 1s;
}
.fromtop-card-enter-active,
.fromtop-card-leave-active {
  transition: all 1s;
  @media only screen and (min-width: 1024px) and (max-height: 1366px) and (orientation: portrait) and (-webkit-min-device-pixel-ratio: 1.5) {
    transition: none;
  }
}
.fromtop-card-enter-from {
  transform: translateY(100%);
  @media only screen and (min-width: 1024px) and (max-height: 1366px) and (orientation: portrait) and (-webkit-min-device-pixel-ratio: 1.5) {
    transform: translateY(0%);
  }
}
.fromtop-card-enter-to {
  opacity: 1;
}

/* ----------- iPad Pro ----------- */
/* Portrait and Landscape */
@media only screen and (min-width: 1024px) and (max-height: 1366px) and (-webkit-min-device-pixel-ratio: 1.5) {
}
/* Landscape */
@media only screen and (min-width: 1024px) and (max-height: 1366px) and (orientation: landscape) and (-webkit-min-device-pixel-ratio: 1.5) {
  .grid {
    transform: translateY(-20px);
  }
}

/* Portrait */
@media only screen and (min-width: 1024px) and (max-height: 1366px) and (orientation: portrait) and (-webkit-min-device-pixel-ratio: 1.5) {
  .grid {
    grid-template-columns: repeat(2, 1fr) repeat(2, 380px) repeat(2, 1fr);
    grid-template-rows: 28vh 70vh;
    &__item:nth-child(1) {
      grid-column: 1 / span 3;

      align-self: center;
    }
    .grid__item:nth-child(3) {
      grid-column: 2 / span 1;
    }
    .grid__item:nth-child(4) {
      grid-row: 2 / span 1;
      align-self: start;
    }

    .card-1 {
      max-width: 50%;
      transform: translateY(0);
      position: absolute;
      top: 15vw;
      left: 10vw;
      .card__img {
        --width-img: 20vw;
      }
    }
    .card-2 {
      position: absolute;
      width: 20%;
      top: 25%;
      left: auto;
      right: 5%;
      .frame-img {
        width: 20vw;
      }
      .bg-img-frame {
        width: 20vw;
        height: 15vw;
      }
    }
    .card-3 {
      width: 35vw;
      transform: translate(0);
      position: absolute;
      left: 8vw;
      .card__img {
        --width-img: 26vw;
        left: 5%;
      }
    }
    .card-4 {
      top: auto;
      bottom: 22.5vh;
      .card__img {
        .img {
          height: 20vw;
        }
      }
    }
    .card-5,
    .card-3 {
      top: 32%;
    }
    .card-5 {
      position: absolute;
      transform: translate(0);
      width: 35vw;

      right: 8vw;
      .card__img {
        --width-img: 26vw;
        left: 5%;
      }
    }
  }
}
</style>
<style lang="scss">
@keyframes books-move {
  0% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(0%);
  }
  100% {
    transform: translateY(200%);
  }
}
@keyframes top-hidden {
  0% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-20%);
  }
  100% {
    transform: translateY(-100%);
  }
}
@keyframes top-visible {
  0% {
    transform: translateY(-100%);
  }
  50% {
    transform: translateY(-20%);
  }
  100% {
    transform: translateY(0%);
  }
}
@keyframes scale-laptop-visible {
  0% {
    transform: scale(0.8);
  }
  80% {
    transform: scale(0.8);
  }
  100% {
    transform: scale(1);
  }
}
</style>
